import { HarmonisedSystemCodeApiClient } from '@fourthwall/services/dist/HarmonisedSystemCodeApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useHSCodesQuery = createQueryHook(HarmonisedSystemCodeApiClient.getHSCodes, {
  queryKey: ['HSCodes'],
})
